import React, { useRef, useState } from "react";

// Assets (consider lazy loading these images)
import logoImage from "../../assets/LogoImage.png";
import { useNavigate } from "react-router-dom";
import SC from "./style";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import ThankYouCard from "../../components/ThankYouCard";

// Component
const LetConnects = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    message: "",
    location: { lat: null, lon: null },
    browserData: {
      userAgent: navigator.userAgent,
      screenSize: `${window.screen.width}x${window.screen.height}`,
      language: navigator.language,
    },
  });
  const [loading, setLoading] = useState(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const recaptchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  // // Get user location
  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         setFormData((prev) => ({
  //           ...prev,
  //           location: {
  //             lat: position.coords.latitude,
  //             lon: position.coords.longitude,
  //           },
  //         }));
  //       },
  //       (error) => console.error("Geolocation error:", error),
  //       { timeout: 10000 }
  //     );
  //   }
  // }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Please complete the reCAPTCHA.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `/api/rest/users/v2/contact`,
        {
          ...formData,
          captcha: captchaToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_API_KEY,
          },
        },
      );
      setIsSubmitted(true);

      console.log("Response:", response.data);

      // Reset form data and CAPTCHA
      setFormData({ name: "", email: "", phone_number: "", message: "" });
      recaptchaRef.current?.reset();
      setCaptchaToken(""); // Reset captcha token
      setLoading(false);
    } catch (error) {
      // Reset form data and CAPTCHA
      setFormData({ name: "", email: "", phone_number: "", message: "" });
      recaptchaRef.current?.reset();
      setCaptchaToken(""); // Reset captcha token
      setLoading(false);
      console.error("Error:", error.response?.data || error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onCaptchaChange = (token) => {
    setCaptchaToken(token); // Save token
    setIsCaptchaValid(!!token); // Ensure the token is valid
  };

  const handleClick = () => {
    navigate("/welcome");
  };

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <>
      <SC.PageWrapper>
        <SC.TopBar>
          <img
            src={logoImage}
            alt="Company Logo"
            loading="lazy"
            onClick={handleNavigate}
            style={{ cursor: "pointer" }}
          />
        </SC.TopBar>

        <SC.MainContent>
          <SC.ImageWrapper>
            {/* <img
            // src={deviceImage}
            alt="Device showcase"
            loading="lazy"
            // width="600"
            // height="400"
          /> */}
          </SC.ImageWrapper>

          <SC.FormWrapper>
            {!isSubmitted ? (
              <SC.Card>
                <SC.HeaderContainer>
                  <SC.Heading>
                    Let’s Connect & Elevate Your Workflow!
                  </SC.Heading>
                  <SC.SubText>Have questions or need a demo?</SC.SubText>
                </SC.HeaderContainer>

                <SC.Form onSubmit={handleSubmit}>
                  <SC.Input
                    type="text"
                    name="name"
                    placeholder="Your full name*"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <SC.InputWrapper>
                    <SC.Input
                      type="email"
                      name="email"
                      placeholder="Your email address*"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    <SC.Input
                      type="tel"
                      name="phone_number"
                      placeholder="Your phone number"
                      value={formData.phone_number}
                      onChange={handleChange}
                    />
                  </SC.InputWrapper>

                  <SC.TextArea
                    name="message"
                    placeholder="Message*"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />

                  <SC.RecaptchaWrapper>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey="6Ld9ItcqAAAAAGfJwyeL76iqasJcMzR1Gm2yDlEm"
                      onChange={onCaptchaChange}
                    />
                  </SC.RecaptchaWrapper>
                  <SC.SubmitButton
                    type="submit"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    disabled={!isCaptchaValid || loading}
                    aria-label="Submit the form"
                  >
                    Submit Now
                  </SC.SubmitButton>
                </SC.Form>

                <SC.Divider>
                  <span>OR</span>
                </SC.Divider>

                <SC.AlternativeAction>
                  <span>Have access code?</span>
                  <SC.AlternativeButton type="button" onClick={handleClick}>
                    Try me
                  </SC.AlternativeButton>
                </SC.AlternativeAction>
              </SC.Card>
            ) : (
              <ThankYouCard />
            )}
          </SC.FormWrapper>
        </SC.MainContent>
      </SC.PageWrapper>
    </>
  );
};

export default LetConnects;
